import React, { FunctionComponent, useCallback, useState } from 'react';

import { Text } from '@yandex-360/orb-components/dist/components/Text';
import { useSelector } from 'react-redux';

import { i18n } from '../../../../../../../../helpers/i18n';
import { selectIsTelemessengerExpEnabled } from '../../../../../../../flags/selectors';
import { Island } from '../../../../island';
import { SettingsTumbler } from '../../../../tumblers';
import css from './styles.css';

export const NewUiSection: FunctionComponent = () => {
    // только для визуального эффекта, что что-то переключилось, а не сломалось
    const [checked, setChecked] = useState(false);

    const isTelemessengerExpEnabled = useSelector(selectIsTelemessengerExpEnabled);

    const onTumblerChange = useCallback(() => {
        setChecked((prev) => !prev);

        window.location.href = '/toggle-telemost-3-0';
    }, []);

    if (!isTelemessengerExpEnabled) {
        return null;
    }

    return (
        <Island className={css.newUiWrapper}>
            <SettingsTumbler
                testId="new-ui-toggle"
                label={i18n('settings-v2', 'new-ui-tumbler-label')}
                checked={checked}
                midSlot={
                    <div className={css.badge}>
                        <Text color="inverse" typography="caption-md-medium">
                            NDA
                        </Text>
                    </div>
                }
                onChange={onTumblerChange}
            />
        </Island>
    );
};
